<div class="flex-column gap-4 animated fadeIn">
    <div class="flex-column gap-4" style="max-width: 1200px;">
        <div class="flex-column gap-2">
            <span>Enter a URL to defang it</span>
            <div class="flex-row gap-2 align-items-center">
                <input type="text" class="m-0 f-1-0" style="height: 32px; max-width: 500px"
                       (keyup.enter)="defangUrl();"
                       placeholder="URL"
                       [(ngModel)]="defangUrlTxt">
                <btn-c [isDisabled]="!defangUrlTxt || defangUrlInProcess" (action)="defangUrl();">
                    Defang URL
                </btn-c>
            </div>
        </div>
        <div class="flex-column" style="height: 140px; max-width: 700px; font-size: 14px;">
            <loader height="75" width="75" style="opacity: 0.8; align-self: center;" *ngIf="defangUrlInProcess"></loader>
            <div class="flex-column gap-2 bg-success bg-opacity-10 border border-success rounded-2 p-3"
                 *ngIf="defangUrlResult && !defangUrlInProcess">
                <div class="flex-row justify-content-between">
					<span>{{defangUrlResult}}</span>
                    <i class="far fa-copy copy-link opacity-75 hvr-opacity" tooltip="Copy URL"
                       style="font-size: 15px;"
                       (click)="gs.copyToClipboard(defangUrlResult);"></i>
                </div>
            </div>
        </div>

        <hr class="m-0"/>
        <div class="flex-column gap-2">
            <span>Enter a defanged URL to undefang it</span>
            <div class="flex-row gap-2 align-items-center">
                <input type="text" class="m-0 f-1-0" style="height: 32px; max-width: 500px"
                       (keyup.enter)="undefangUrl();"
                       placeholder="Defanged URL"
                       [(ngModel)]="undefangUrlTxt">
                <btn-c [isDisabled]="!undefangUrlTxt || undefangUrlInProcess" (action)="undefangUrl();">
                    Undefang URL
                </btn-c>
            </div>
        </div>
        <div class="flex-column" style="height: 140px; max-width: 700px; font-size: 14px;">
            <loader height="75" width="75" style="opacity: 0.8; align-self: center;" *ngIf="undefangUrlInProcess"></loader>
            <div class="flex-column gap-2 bg-success bg-opacity-10 border border-success rounded-2 p-3"
                 *ngIf="undefangUrlResult && !undefangUrlInProcess">
                <div class="flex-row justify-content-between">
					<span>{{undefangUrlResult}}</span>
                    <i class="far fa-copy copy-link opacity-75 hvr-opacity" tooltip="Copy URL"
                       style="font-size: 15px;"
                       (click)="gs.copyToClipboard(undefangUrlResult);"></i>
                </div>
            </div>
        </div>
    </div>
</div>

